export default __webpack_public_path__ + "static/media/2-mini.074690db.webp";